var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSupervision = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 9.091a1.09 1.09 0 1 1 0-2.18 1.09 1.09 0 0 1 0 2.18"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.182 8S15.636 4 12 4C8.327 4 5.82 8 5.82 8S7.637 12 12 12c4.328 0 6.182-4 6.182-4m-3.637 0A2.53 2.53 0 0 1 12 10.545 2.53 2.53 0 0 1 9.455 8 2.53 2.53 0 0 1 12 5.455 2.53 2.53 0 0 1 14.545 8M11.633 14.005h.737l.005 4.562 2.1-2.095.53.53-2.996 3.003-3.004-2.996.53-.53 2.104 2.09zM15.861 12.382l.52-.521 3.227 3.226.007-2.966h.749v4.243h-4.243v-.75l2.966-.006zM7.104 11.861l.52.521-3.226 3.227 2.966.006v.75H3.121v-4.243h.75l.006 2.966z",
  clipRule: "evenodd"
})));
export default SvgSupervision;